import * as React from "react";
const SvgList320Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M2.925 1.75 2 2.683l.458.466.86.851-.86.85L2 5.318l.925.933L5.175 4l-2.25-2.25ZM17.97 3H7v2h10.97V3ZM7 9h10.97v2H7V9ZM2.925 7.75 2 8.683l.458.466.86.851-.86.85-.458.467.925.933L5.175 10l-2.25-2.25ZM7 15h11.062v2H7v-2Zm-4.075-1.25L2 14.683l.458.466.86.851-.86.85-.458.467.925.933L5.175 16l-2.25-2.25Z"
    })
  );
export default SvgList320Px;
